import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-result-admin-config',
  templateUrl: './frame-result-admin-config.component.html',
  styleUrls: ['./frame-result-admin-config.component.scss']
})
export class AtwFrameResultAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // xem đang ở page hay admin
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  @Output() changeOptionConfig = new EventEmitter<any>();

  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
  ];

  /** Danh sách ngành hàng */
  main_sectors: any = [];
  configMode: 'basic' | 'advanced' = 'basic';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    private vhAlgorithm: VhAlgorithm,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Lấy danh sách ngành hàng
      forkJoin([
        this.http.get('assets/data/group/main_sectors.json'),
      ]).subscribe(([main_sectors]: any) => {
        this.main_sectors = this.vhAlgorithm.sortVietnamesebyASC(main_sectors.filter((item) => !['basic', 'branchs', 'member'].includes(item.value)), 'label');
      });

      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-result__products']['gap'],
          10
        );
      }
    }
  }


  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  //Hàm update class
  updateClass() {
    this.updateObject();
  }


  //Hàm update class
  updateConfig() {
    this.updateObject();
  }
  
}
